webpackJsonp([1],{

/***/ 135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(37)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('lang.title')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.versionTable,
      "default-expand-all": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('lang.category')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$t(("lang." + (scope.row.category)))))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(categoryProps) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": categoryProps.row.data
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "expand"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(props) {
              return [_c('el-form', {
                staticClass: "demo-table-expand",
                attrs: {
                  "label-position": "left"
                }
              }, [_c('el-form-item', {
                attrs: {
                  "label": _vm.$t('lang.description')
                }
              }, [_c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.desc[_vm.$lang]))])]), _vm._v(" "), _c('el-form-item', {
                attrs: {
                  "label": _vm.$t('lang.releaseNote')
                }
              }, [_c('br'), _vm._v(" "), _vm._l((props.row.releaseNote[_vm.$lang]), function(item) {
                return _c('li', [_vm._v(_vm._s(item))])
              })], 2)], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.name'),
            "prop": "name"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.version'),
            "prop": "version"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.updateDate'),
            "prop": "publishDate"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.download')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(props) {
              return [_c('el-popover', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (props.row.category === 'software'),
                  expression: "props.row.category === 'software'"
                }],
                ref: "popover4",
                attrs: {
                  "placement": "right",
                  "width": "400",
                  "trigger": "hover"
                }
              }, _vm._l((props.row.url), function(v, k) {
                return _c('li', [_c('a', {
                  attrs: {
                    "href": v
                  }
                }, [_vm._v(_vm._s(k))])])
              })), _vm._v(" "), _c('el-button', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (props.row.category === 'software'),
                  expression: "props.row.category === 'software'"
                }, {
                  name: "popover",
                  rawName: "v-popover:popover4",
                  arg: "popover4"
                }]
              }, [_vm._v(_vm._s(_vm.$t('lang.download')))]), _vm._v(" "), _c('el-button', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (props.row.category !== 'software'),
                  expression: "props.row.category !== 'software'"
                }],
                on: {
                  "click": function($event) {
                    _vm.openLink(props.row.url)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('lang.download')))]), _vm._v(" "), _c('el-button', {
                on: {
                  "click": function($event) {
                    _vm.historyDialog = true;
                    _vm.historyTable = _vm.historyInfo[props.row.name]
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('lang.history')))])]
            }
          }])
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('lang.history'),
      "visible": _vm.historyDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.historyDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.historyTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "publishDate",
      "label": _vm.$t('lang.updateDate'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "version",
      "label": _vm.$t('lang.version'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lang.download')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-popover', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.category === 'software'),
            expression: "props.row.category === 'software'"
          }],
          ref: "popover5",
          attrs: {
            "placement": "right",
            "width": "400",
            "trigger": "hover"
          }
        }, _vm._l((props.row.url), function(v, k) {
          return _c('li', [_c('a', {
            attrs: {
              "href": v
            }
          }, [_vm._v(_vm._s(k))])])
        })), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.category === 'software'),
            expression: "props.row.category === 'software'"
          }, {
            name: "popover",
            rawName: "v-popover:popover5",
            arg: "popover5"
          }]
        }, [_vm._v(_vm._s(_vm.$t('lang.download')))]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.category !== 'software'),
            expression: "props.row.category !== 'software'"
          }],
          on: {
            "click": function($event) {
              _vm.openLink(props.row.url)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('lang.download')))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by alex on 2017/7/12.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  en: {
    lang: {
      category: 'Category',
      name: 'Name',
      version: 'Version',
      updateDate: 'Update Date',
      download: 'Download',
      firmware: 'Firmware(Only for test)',
      software: 'Software(Only for test)',
      description: 'Description',
      releaseNote: 'Release Note',
      history: 'All Version',
      title: 'UFACTORY beta Download Center'
    }
  },
  cn: {
    lang: {
      category: '类型',
      name: '名称',
      version: '版本号',
      updateDate: '更新日期',
      download: '下载',
      firmware: '固件(仅供测试)',
      software: '软件(仅供测试)',
      description: '描述',
      releaseNote: '更新日志',
      history: '历史版本',
      title: 'UFACTORY 测试版 下载中心'
    }
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(37)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(141),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang__ = __webpack_require__(39);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var userLang = navigator.language || navigator.userLanguage;
console.log('userLang: ' + userLang);
if (userLang === 'zh-CN') {
  userLang = 'cn';
} else {
  userLang = 'en';
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$lang = userLang;

var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: userLang, // set locale
  messages: __WEBPACK_IMPORTED_MODULE_8__lang__["a" /* default */] // set locale messages
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      historyDialog: false,
      historyTable: [],
      versionInfo: {},
      historyInfo: {},
      showHistoryInfo: {},
      versionTable: []
    };
  },
  mounted: function mounted() {
    this.fetchVersions();
    this.fetchHistory();
  },

  methods: {
    openLink: function openLink(url) {
      window.open(url);
    },
    fetchVersions: function fetchVersions() {
      var _this = this;

      this.$http.get("/releases/updates.json?v=" + Math.random()).then(function (response) {
        var body = response.data;
        _this.versionInfo = {};
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(body).forEach(function (key) {
          var category = body[key].category;
          if (_this.versionInfo[category] === undefined) {
            _this.versionInfo[category] = [];
          }
          _this.versionInfo[category].push({
            category: category,
            url: body[key].url,
            version: body[key].version,
            publishDate: body[key].publishDate,
            releaseNote: body[key].releaseNote,
            name: body[key].name,
            desc: body[key].introduction
          });
        });
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.versionInfo).forEach(function (key) {
          _this.versionTable.push({ category: key, data: _this.versionInfo[key] });
        });
      }).catch(function (err) {
        return console.log(err);
      });
    },
    fetchHistory: function fetchHistory() {
      var _this2 = this;

      this.$http.get("/releases/history.json?v=" + Math.random()).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data).forEach(function (key) {
          var versions = response.data[key];
          if (_this2.historyInfo[key] === undefined) {
            _this2.historyInfo[key] = [];
          }
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(versions).forEach(function (vk) {
            _this2.historyInfo[key].push(versions[vk]);
          });
        });
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.historyInfo));
      });
    }
  }
});

/***/ })

},[85]);


// WEBPACK FOOTER //
// static/js/app.d940d1ad2d18856fa606.js